import React from 'react'
import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"

export default function DataTableDetalheRegras({arrayExibicao,detalhe}) {
    arrayExibicao = arrayExibicao.map((item) => {
        return {
            detalhe: item
        }
    })
    return (
        <DataTable 
            value={arrayExibicao}
            responsive 
            rowHover 
            paginator 
            rows={10} 
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} resultados encontrados"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        >
            <Column 
                field='detalhe' 
                header={detalhe} 
                headerStyle={{ width: '8em', textAlign: 'center' }} 
                bodyStyle={{ textAlign: 'center', overflow: 'visible' }} 
                filter
                filterPlaceholder={`Buscar por ${detalhe}`} 
            />
        </DataTable>
    )
}
